module.exports = __webpack_public_path__ + "static/media/bg_short_trips.eb161d2b.jpg";